import BaseFoundation from '../base/foundation';
export default class DropdownFoundation extends BaseFoundation {
  handleVisibleChange(visible) {
    this._adapter.setPopVisible(visible);

    this._adapter.notifyVisibleChange(visible);
  }

}